// Independent page composition for Technology Program Management.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function ProgramManagementPage({ service }) {
  return h(PageFrame, { service, tone: 'split', hero: diagram(service, 'collaboration') },
    section('Clear ownership across people and systems', split(context(service), scope())),
    section('Agree how the work will run', deliverables(service)),
    section(null, split(answer(service), scenario(service)), { theme: 'ai-wash' })
  );
};
